<template>
  <section class="section">
    <span class="back" @click="$router.back()">
      <i class="fal fa-chevron-left"></i>
    </span>
    <div class="page-header">
      <h3 class="page-title" v-if="($route.query.id = $route.query.id)">
        Update Banner
      </h3>
      <h3 class="page-title" v-else>Add Banner</h3>
    </div>
    <div class="box">
      <ValidationObserver v-slot="{ handleSubmit }">
        <div class="file is-centered">
          <div
            class="image"
            :style="{ 'background-image': `url( ${imageData} )` }"
            @click="chooseImage"
          >
            <div class="upload-btn">
              <i class="fas fa-camera"></i>
            </div>
          </div>
        </div>
        <input
          class="isFile"
          name="Image"
          ref="fileinput"
          type="file"
          @input="onSelectFile"
        />
        <div class="container has-text-centered" v-if="$route.query.id == ''">
          <ValidationProvider rules="required|image" v-slot="{ errors }">
            <input type="text" style="display: none" v-model="form.file" />
            <span style="color: red; font-size: 12px">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="container has-text-centered" v-if="selectFiles == true">
          <span style="color: red; font-size: 12px">{{
            checkImageUpload
          }}</span>
        </div>
        <div class="columns is-multiline">
          <div class="column is-4">
            <div class="field">
              <label for="" class="label">Banner Type</label>
              <div class="control">
                <ValidationProvider
                  name="bannerType"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <select
                    v-model="form.bannerType"
                    class="input"
                    :class="{ error: errors[0] }"
                    @click.prevent="select()"
                  >
                    <option value="">Select Banner Type</option>
                    <option
                      v-for="(item, idx) in banner"
                      :key="idx"
                      :value="item._id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label for="" class="label">Online Date</label>
              <div class="control mt-3">
                <ValidationProvider
                  name="online"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <date-picker
                    v-model="form.online"
                    value="date"
                    :clearable="false"
                    style="width: 100%"
                    :class="{ error: errors[0] }"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label for="" class="label">Close Date</label>
              <div class="control mt-3">
                <ValidationProvider
                  name="closeDate"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <date-picker
                    v-model="form.closeDate"
                    valueType="date"
                    :clearable="false"
                    style="width: 100%"
                    :class="{ error: errors[0] }"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label for="" class="label">Link / Url</label>
              <div class="control">
                <!-- <ValidationProvider name="linkUrl" rules="required" v-slot="{ errors }"> -->
                <input
                  type="text"
                  class="input"
                  v-model="form.linkUrl"
                  placeholder="Some Link or Web site Url...."
                />
                <!-- </ValidationProvider> -->
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label for="" class="label">Name Banner</label>
              <div class="control">
                <ValidationProvider
                  name="name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    class="input"
                    v-model="form.name"
                    :class="{ error: errors[0] }"
                    placeholder="Name...."
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label for="" class="label">WebApp</label>
              <div class="control">
                <ValidationProvider
                  name="WebApp"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <select v-model="form.WebApp" class="input is-focused">
                    <option>web</option>
                    <option>app</option>
                    <option>mobile</option>
                  </select>
                  <span style="color: red; font-size: 12px">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="column" v-if="isInPostAd">
            <div class="field">
              <label for="" class="label">Select Company</label>
              <div class="control">
                <selection
                  v-model="form.empId"
                  :data="emp"
                  name="Company"
                  :selection="clickEmp"
                  :updateText="selectedJobs"
                />
                <br />
              </div>
            </div>
          </div>
          <div class="column is-4" v-if="($route.query.id = $route.query.id)">
            <div class="field">
              <label for="" class="label">Status</label>
              <div class="control sw-control">
                <div class="sw-container mt-2">
                  <label class="sw-label" for="use-published" name="published">
                    <input
                      type="checkbox"
                      @click="form.status = !form.status"
                      id="use-published"
                      :checked="form.status"
                    />
                    <div class="sw-slider"></div>
                  </label>
                  <label for="use-published">Publish</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- {{form}} -->
        <button
          class="button primary"
          @click="handleSubmit(update)"
          v-if="($route.query.id = $route.query.id)"
        >
          Update
        </button>
        <button class="button primary" @click="handleSubmit(save)" v-else>
          Save
        </button>
      </ValidationObserver>
    </div>
  </section>
</template>

<script>
import { GET_REUSE } from "@/graphql/manage/query";
import {
  ADD_BANNER,
  GET_BANNER_BYID,
  UPDATE_BANNER,
} from "@/graphql/banner/banner";
import { apolloClient } from "@/services/apollo-client";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import selection from "../others/empSelection";
import axios from "axios";
import vClickOutside from "v-click-outside";
import { getEmployersApi } from "@/apis/employer-api";
export default {
  components: { DatePicker, selection },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data: () => ({
    result: [],
    banner: [],
    imageData: null,
    checkImageUpload: null,
    selectFiles: false,
    selectedBannerType: "",
    form: {
      file: {},
      bannerType: [""],
      linkUrl: "",
      status: true,
      online: new Date(),
      closeDate: new Date(),
      WebApp: "",
      name: "",
      empId: [],
    },
    clickEmp: false,
    isInPostAd: false,
    selectedJobs: [],
    emp: [],
  }),
  computed: {
    getEmp() {
      const filter = this.emp.filter((i) => {
        return this.form.empId.includes(i._id);
      });
      const mappers = filter.map((i) => i.name);
      return mappers;
    },
  },
  methods: {
    chooseImage() {
      this.$refs.fileinput.click();
    },
    async onSelectFile() {
      this.selectFiles = true;
      const input = this.$refs.fileinput;
      const files = input.files;

      const file = files[0];
      // console.log(file, "ok")
      const formData = new FormData();

      formData.append("file", file);
      axios.defaults.headers.common[
        "Authorization"
      ] = this.$store.getters.Token;
      const res = await axios.post(`${this.$urlBanner}`, formData);
      //console.log(res.data.file, "YES");
      this.form.file = res.data.file;

      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input is-focused", files[0]);
      }
      if (this.form.file) {
        this.checkImageUpload = null;
      } else {
        this.checkImageUpload = "Select File Type .JPG .PNG .JPEG .SVG";
      }
    },
    async save() {
      // save banner
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      await apolloClient.mutate({
        mutation: ADD_BANNER,
        variables: {
          file: this.form.file,
          url: this.form.linkUrl,
          onlineDate: this.form.online,
          closeDate: this.form.closeDate,
          status: this.form.status,
          BannerTypeId: this.form.bannerType,
          WebApp: this.form.WebApp,
          name: this.form.name,
          empId: this.form.empId,
        },
      });
      this.$router.back();
    },
    async getBanner() {
      //console.log(this.funcs)
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          name: this.banner,
          type: "BannerType",
          page: 1,
          perPage: 100,
        },
      });

      this.banner = res.data.getReuse.reuseType;
    },
    async getData() {
      if (this.$route.query.id) {
        const res = await apolloClient.query({
          query: GET_BANNER_BYID,
          variables: {
            id: this.$route.query.id,
          },
        });
        this.result = res.data.findBanner;
        this.form.linkUrl = this.result.url;
        this.imageData = this.result.image.src;
        this.form.bannerType = this.result.BannerTypeId._id;
        this.form.status = this.result.status;
        this.form.online = new Date(this.result.onlineDate);
        this.form.closeDate = new Date(this.result.closeDate);
        this.form.WebApp = this.result.WebApp;
        this.form.name = this.result.name;
        this.selectedJobs = this.result.empId.map((i) => i._id);
        if (this.result.BannerTypeId._id === "64994809bed61605b415f572")
          this.isInPostAd = true;
      }
    },
    async update() {
      // save banner
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      await apolloClient.mutate({
        mutation: UPDATE_BANNER,
        variables: {
          bannerId: this.$route.query.id,
          file: this.form.file,
          url: this.form.linkUrl,
          onlineDate: this.form.online,
          closeDate: this.form.closeDate,
          status: this.form.status,
          BannerTypeId: this.form.bannerType,
          WebApp: this.form.WebApp,
          name: this.form.name,
          empId: this.form.empId,
        },
      });
      this.$router.back();
    },
    select() {
      if (this.form.bannerType === "64994809bed61605b415f572") {
        this.isInPostAd = true;
      } else {
        this.isInPostAd = false;
      }
    },
    async fetchCompany() {
      const companies = await getEmployersApi();
      this.emp = companies.map((i) => {
        return {
          _id: i._id,
          name: i.companyName,
        };
      });
    },
  },
  async created() {
    await this.fetchCompany();
    await this.getData();
    await this.getBanner();
  },
};
</script>

<style lang="scss" scoped>
.file {
  display: flex;
}

.banner {
  cursor: pointer;
  display: block;
  max-height: 100%;
}

.image {
  background-color: var(--light-grey-color);
  position: relative;
  cursor: pointer;
  margin: 0 auto;
  width: 300px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center center;
  padding: 20px;
  border: 1px solid var(--border-color);

  &:hover .upload-btn {
    opacity: 1;
  }

  img {
    max-height: 140px;
  }

  .upload-btn {
    transition: opacity 0.3s;
    opacity: 0;

    background-color: rgba(#333, 0.1);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;

    i {
      padding: 5px;
      font-size: 20px;
    }
  }
}

// logo
.label {
  margin-top: 10px;
}

.isFile {
  display: none;
}

.error {
  border: 2px solid rgb(255, 86, 8);
  color: rgb(255, 80, 15);
}
</style>
